import { render, staticRenderFns } from "./ingresoCorreo.vue?vue&type=template&id=d373f498&scoped=true&"
import script from "./ingresoCorreo.vue?vue&type=script&lang=js&"
export * from "./ingresoCorreo.vue?vue&type=script&lang=js&"
import style0 from "./ingresoCorreo.vue?vue&type=style&index=0&id=d373f498&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d373f498",
  null
  
)

export default component.exports